const selectedStationsKey = 'selectedStations';

export const saveSelectedStationsToLocalStorage = (selectedStations) => {
  localStorage.setItem(selectedStationsKey, JSON.stringify(selectedStations));
}

export const loadSelectedStationsFromLocalStorage = () => {
  const state = localStorage.getItem(selectedStationsKey);
  return state ? (JSON.parse(state)) : null;
}